export default __webpack_public_path__ + "static/media/1677.cdbb0cf2.png";